import { render, staticRenderFns } from "./RedirectOverlay.vue?vue&type=template&id=45e354d4&scoped=true"
import script from "./RedirectOverlay.vue?vue&type=script&lang=js"
export * from "./RedirectOverlay.vue?vue&type=script&lang=js"
import style0 from "./RedirectOverlay.vue?vue&type=style&index=0&id=45e354d4&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45e354d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45e354d4')) {
      api.createRecord('45e354d4', component.options)
    } else {
      api.reload('45e354d4', component.options)
    }
    module.hot.accept("./RedirectOverlay.vue?vue&type=template&id=45e354d4&scoped=true", function () {
      api.rerender('45e354d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RedirectOverlay.vue"
export default component.exports